define('viewmodels/secured/explorer/details/tabs/actions/ActionGroup',[], function () {

    var ActionGroup = function(hideFilters) {
        var self = this;
        self.hideFilters = hideFilters || [];

        self.isHidden = ko.computed(function() {
            return _.any(self.hideFilters, function(filter) {
                return filter();
            });
        });

        self.actions = [];
    };

    return ActionGroup;

});
